import { getAttributeFormatDisplay } from '../lib/FormatUtils';
let _ = require('lodash');

function processAnyOfSchemaEntry(
  item,
  idx,
  {
    inputSchema,
    value,
    thisRowIndex,
    key,
    __displayName,
    __name,
    __txName,
    __parentName,
    typeSuffix,
    controlledByAttr,
    isFromSchemaSpec,
    isMetaData,
    decodedOut,
    requiredProps,
    depth,
    isFromArrayAnyOf = false, //ensure that array itself doesn't get added as it's own child
  },
) {
  let decodedChildren;

  if (!_.has(item, 'type') || item.type === 'null') {
    //bypass this entry if type is null
    let decodedEntry = {
      __displayName: __displayName,
      __name: __name,
      __txName: __txName,
      __description: _.has(value, 'description') ? value.description : null,
      __depth: depth,
      __parentName: __parentName,
      __type: 'null',
      __format: null,
      __formatDisplay: 'null',
    };
    if (controlledByAttr) {
      decodedEntry.__controlledBy = controlledByAttr;
    }
    decodedOut = mergeEntries([...decodedOut, decodedEntry]);
  } else if (_.has(item, 'properties')) {
    let decodedEntry = {
      __displayName: __displayName,
      __name: __name,
      __txName: __txName,
      __description: _.has(value, 'description') ? value.description : null,
      __depth: depth,
      __parentName: __parentName,
      __type: 'object',
      __format: _.has(value, 'format') ? value.format : null,
      __formatDisplay: 'object',
    };

    if (controlledByAttr) {
      decodedEntry.__controlledBy = controlledByAttr;
    }

    if (isFromSchemaSpec) {
      decodedEntry.__fromSchemaSpec = true;
    }

    if (isMetaData) {
      decodedEntry.__isMetaData = true;
    }

    decodedChildren = convertNestedToFlat(
      item.properties,
      value.required,
      thisRowIndex,
      __name,
      getAttrSchema(inputSchema, __name),
      typeSuffix,
      depth + 1,
      controlledByAttr,
      isFromSchemaSpec,
      isMetaData,
    );

    //ensure that array itself doesn't get added as it's own child
    decodedOut =
      isFromArrayAnyOf === false
        ? mergeEntries([...decodedOut, decodedEntry, ...decodedChildren])
        : mergeEntries([...decodedOut, ...decodedChildren]);
  } else if (item.type === 'array' && _.has(item, 'items')) {
    //array of items
    if (item.items.type === 'object') {
      let decodedEntry = {
        __displayName: __displayName,
        __name: __name,
        __txName: __txName,
        __description: _.has(value, 'description') ? value.description : null,
        __depth: depth,
        __parentName: __parentName,
        __type: 'array',
        __format: _.has(value, 'format') ? value.format : null,
        __formatDisplay: 'array',
      };

      // decodedEntry.__formatDisplay = _.has(ALL_FORMATS, decodedEntry.__format)
      //   ? ALL_FORMATS[decodedEntry.__format].label
      //   : decodedEntry.__format;

      if (controlledByAttr) {
        decodedEntry.__controlledBy = controlledByAttr;
      }

      if (isFromSchemaSpec) {
        decodedEntry.__fromSchemaSpec = true;
      }

      if (isMetaData) {
        decodedEntry.__isMetaData = true;
      }

      decodedChildren = _.has(item.items, 'properties')
        ? convertNestedToFlat(
            item.items.properties,
            value.required,
            thisRowIndex,
            __name,
            getAttrSchema(inputSchema, __name),
            typeSuffix,
            depth + 1,
            controlledByAttr ? controlledByAttr : __name,
            isFromSchemaSpec,
            isMetaData,
          )
        : [];

      decodedOut = mergeEntries([...decodedOut, decodedEntry, ...decodedChildren]);
      //2. array of objects
    } else if (_.has(item.items, 'anyOf') || _.has(item.items, 'oneOf')) {
      //items could be anyOf/oneOf.
      //4. or array is a oneOf object
      console.log(`skip ${key} (array anyOf/oneOf)`);
    } else {
      //1. array of simple entries
      let decodedEntry = {
        __name: __name,
        __txName,
        __displayName,
        __parentName,
        __description: _.has(value, 'description') ? value.description : null,
        __depth: depth,
        __type: 'array',
      };
      decodedEntry.__format = _.has(value, 'format') ? value.format : null;
      decodedEntry.__formatDisplay = 'array';

      if (controlledByAttr) {
        decodedEntry.__controlledBy = controlledByAttr;
      }

      if (isFromSchemaSpec) {
        decodedEntry.__fromSchemaSpec = true;
      }

      if (isMetaData) {
        decodedEntry.__isMetaData = true;
      }

      decodedOut = mergeEntries([...decodedOut, decodedEntry]);
    }
  } else {
    //bypass this entry if type is null
    let decodedEntry = {
      __displayName: __displayName,
      __name: __name,
      __txName: __txName,
      __description: _.has(value, 'description') ? value.description : null,
      __depth: depth,
      __parentName: __parentName,
      __type: item.type,
    };

    if (controlledByAttr) {
      decodedEntry.__controlledBy = controlledByAttr;
    }

    decodedEntry.__format = _.has(item, 'format') ? item.format : null;

    decodedEntry.__formatDisplay = getAttributeFormatDisplay(decodedEntry);

    decodedOut = mergeEntries([...decodedOut, decodedEntry]);
  }

  return decodedOut;
}

function mergeEntries(entries) {
  const byTxName = {};

  _.forEach(entries, (entry) => {
    const { __txName } = entry;
    const oldEntry = byTxName[__txName];

    // if two entries have the same txName, merge them
    if (oldEntry) {
      let mergedEntry;

      // non-null entries completely overwrite null entries
      if (
        (!oldEntry.__type || oldEntry.__type === 'null') &&
        entry.__type &&
        entry.__type !== 'null'
      ) {
        mergedEntry = entry;
      } else if (
        (!entry.__type || entry.__type === 'null') &&
        oldEntry.__type &&
        oldEntry.__type !== 'null'
      ) {
        mergedEntry = oldEntry;
      } else {
        mergedEntry = _.merge({}, oldEntry, entry);
      }

      //check if merge is needed?
      const oldType = oldEntry.__type;
      const newType = entry.__type;
      mergedEntry.__type = !_.includes(_.split(oldType, ' or '), newType)
        ? `${oldType} or ${newType}`
        : oldType;

      const oldFormatDisplay = oldEntry.__formatDisplay;
      const newFormatDisplay = entry.__formatDisplay;
      mergedEntry.__formatDisplay = !_.includes(_.split(oldFormatDisplay, ' or '), newFormatDisplay)
        ? `${oldFormatDisplay} or ${newFormatDisplay}`
        : oldFormatDisplay;

      const oldFormat = oldEntry.__format;
      const newFormat = entry.__format;
      mergedEntry.__format = !oldFormat
        ? newFormat
        : !_.includes(_.split(oldFormat, ' or '), newFormat)
          ? `${oldFormat} or ${newFormat}`
          : oldFormat;

      byTxName[__txName] = mergedEntry;
    } else {
      byTxName[__txName] = entry;
    }
  });

  return _.values(byTxName);
}

function convertNestedToFlat(
  inputSchema,
  requiredProps,
  startRowIndex,
  parentName,
  parentSchema,
  typeSuffix,
  depth = 0,
  controlledByAttr = null,
  isFromSchemaSpec = false,
  isMetaData = false,
) {
  let decodedOut = [];

  for (let key in inputSchema) {
    if (inputSchema.hasOwnProperty(key)) {
      let value = inputSchema[key];
      let thisRowIndex = startRowIndex + decodedOut.length;
      let __name = key;
      let __displayName = key;
      let __txName = key;
      let __parentName = null;

      if (parentName && parentName !== 'undefined' && parentName !== '') {
        const separator = parentSchema?.type === 'array' ? '.[*].' : '.';
        __name = parentName + separator + key;
        __txName = _.replace(__name, /\[\s\]/g, '');
        __parentName = parentName;
      }

      if (_.isObject(value)) {
        let isAnyOf = _.has(value, 'anyOf');
        let isOneOf = _.has(value, 'oneOf');
        let __type = _.has(value, 'type') ? value.type : null;
        let decodedChildren;

        if (isAnyOf || isOneOf) {
          //is anyof or one of. iterate through each item and construct root type, format, formatDisplay
          __type = null;

          let maxLenth = isAnyOf ? value.anyOf.length : value.oneOf.length;
          let initialNumAttrs = decodedOut.length;
          for (let idx = 0; idx < maxLenth; idx++) {
            let itemToProcess = isAnyOf ? value.anyOf[idx] : value.oneOf[idx];
            decodedOut = processAnyOfSchemaEntry(itemToProcess, idx, {
              inputSchema,
              value,
              thisRowIndex,
              key,
              __displayName,
              __name,
              __txName,
              __parentName,
              typeSuffix,
              controlledByAttr,
              isFromSchemaSpec,
              isMetaData,
              decodedOut,
              requiredProps,
              depth,
            });
          }

          // if the anyOf-s lead to the creation of an attribute, skip the
          // attribute creation at the end of this function
          if (decodedOut.length > initialNumAttrs) {
            continue;
          }
        }

        if (__type === 'object') {
          //If object
          let decodedSelf = {
            __displayName: __displayName,
            __name: __name,
            __txName: __txName,
            __description: null,
            __depth: depth,
            __parentName: __parentName,
            __type: __type,
            __format: null,
            __formatDisplay: __type,
          };

          if (isFromSchemaSpec) {
            decodedSelf.__fromSchemaSpec = true;
          }
          if (isMetaData) {
            decodedSelf.__isMetaData = true;
          }
          if (controlledByAttr) {
            decodedSelf.__controlledBy = controlledByAttr;
          }

          //if type is object get an array of children where each child will have a . to its name
          decodedChildren =
            _.has(value, 'properties') && !_.isEmpty(value.properties)
              ? convertNestedToFlat(
                  value.properties,
                  value.required,
                  thisRowIndex,
                  __name,
                  getAttrSchema(inputSchema, __name),
                  typeSuffix,
                  depth + 1,
                  controlledByAttr,
                  isFromSchemaSpec,
                  isMetaData,
                )
              : [];
          decodedOut = [...decodedOut, decodedSelf, ...decodedChildren];
          continue;
        }

        /*
         if processing arrays:
         let's attach new child attributes that are controlled by a parent attribute if v1 array of objects or if v2 anyOf that has at least one array of objects
        */
        if (__type === 'array' && _.has(value, 'items')) {
          if (value.items.type === 'object') {
            //v1 array of objects
            //If array where each entry is an object
            let __typeSuffix = ''; //' in array of objects';
            //add self. then add children
            let decodedSelf = {
              __displayName: __displayName,
              __name: __name,
              __txName: __txName,
              __description: null,
              __depth: depth,
              __parentName: __parentName,
              __type: 'array',
              __format: null,
              __formatDisplay: 'array',
            };

            //TODO: NEX-1102:Temp for JSON array of objects
            if (controlledByAttr) {
              decodedSelf.__controlledBy = controlledByAttr;
            }

            if (isFromSchemaSpec) {
              decodedSelf.__fromSchemaSpec = true;
            }

            if (isMetaData) {
              decodedSelf.__isMetaData = true;
            }

            //get children properties where each child is controlled by this or parent
            decodedChildren =
              _.has(value.items, 'properties') && !_.isEmpty(value.items.properties)
                ? convertNestedToFlat(
                    value.items.properties,
                    value.items.required,
                    thisRowIndex,
                    __name,
                    getAttrSchema(inputSchema, __name),
                    __typeSuffix,
                    depth + 1,
                    controlledByAttr ? controlledByAttr : __name,
                    isFromSchemaSpec,
                    isMetaData,
                  )
                : [];
            decodedOut = [...decodedOut, decodedSelf, ...decodedChildren];
            continue;
          } else if (_.has(value.items, 'anyOf') || _.has(value.items, 'oneOf')) {
            //v2 array items have an anyOf schema structure
            //add self. then add children
            let decodedSelf = {
              __displayName: __displayName,
              __name: __name,
              __txName: __txName,
              __description: null,
              __depth: depth,
              __parentName: __parentName,
              __type: 'array',
              __format: null,
              __formatDisplay: 'array',
            };

            //TODO: NEX-1102:Temp for JSON array of objects
            if (controlledByAttr) {
              decodedSelf.__controlledBy = controlledByAttr;
            }

            if (isFromSchemaSpec) {
              decodedSelf.__fromSchemaSpec = true;
            }

            if (isMetaData) {
              decodedSelf.__isMetaData = true;
            }

            let arrayChildrenToProcess = _.has(value.items, 'anyOf')
              ? value.items.anyOf
              : value.items.oneOf;
            let anyOfItemsDecoded = [];
            for (let idx = 0; idx < arrayChildrenToProcess.length; idx++) {
              let childItem = arrayChildrenToProcess[idx];
              if (_.has(childItem, 'type') && childItem.type === 'object') {
                //only process objects, other types won't generate children.
                anyOfItemsDecoded = processAnyOfSchemaEntry(childItem, idx, {
                  inputSchema,
                  value,
                  thisRowIndex,
                  key,
                  __displayName,
                  __name,
                  __txName,
                  __parentName,
                  typeSuffix: '',
                  controlledByAttr: controlledByAttr ? controlledByAttr : __name,
                  isFromSchemaSpec,
                  isMetaData,
                  decodedOut: anyOfItemsDecoded,
                  requiredProps,
                  depth: depth,
                  isFromArrayAnyOf: true, //ensure that array itself doesn't get added as it's own child
                });
              }
            }

            decodedOut = [...decodedOut, decodedSelf, ...anyOfItemsDecoded];
            continue;
          }
        }
      }

      //object to be added to row
      let decodedEntry = {};
      decodedEntry.__displayName = __displayName;
      decodedEntry.__parentName = __parentName;
      decodedEntry.__name = __name;
      decodedEntry.__txName = __txName;
      //TODO: Empty description till supported on API.
      decodedEntry.__description = _.has(value, 'description') ? value.description : null;
      // decodedEntry.__rowIndex = thisRowIndex;
      // decodedEntry.__groupRowId = parentName ? parentName : 'ROOT_ITEM';
      decodedEntry.__depth = depth;

      //TODO: NEX-1102:Temp for JSON array of objects
      if (controlledByAttr) {
        decodedEntry.__controlledBy = controlledByAttr;
      }

      if (isFromSchemaSpec) {
        decodedEntry.__fromSchemaSpec = true;
      }

      if (isMetaData) {
        decodedEntry.__isMetaData = true;
      }

      if (_.isObject(value)) {
        let entryType = value.type;

        // if (value.type === 'array') {
        //   //TODO: Remove this commented code after nested array validation
        //   // if(_.has(value.items,'format')){
        //   //   entryType =  'array of ' + value.items.format +'s';
        //   // }else{
        //   entryType = 'array of ' + value.items.type + 's';
        //
        //   // }
        // } else {
        //   // if(_.has(value,'format')){
        //   //   entryType = value.format;
        //   // }else{
        //   entryType = value.type;
        //   //}
        // }

        decodedEntry.__type = entryType;
        //decodedEntry.__type = typeSuffix ? entryType + typeSuffix : entryType;
        decodedEntry.__format = _.has(value, 'format') ? value.format : null;

        decodedEntry.__formatDisplay = getAttributeFormatDisplay(decodedEntry);
      }
      decodedOut.push(decodedEntry);
    }
  }

  return decodedOut;
}

function flattenSchema(
  inputSchema,
  requiredProps,
  startRowIndex,
  parentName,
  typeSuffix,
  controlledByAttr = null,
  isFromSchemaSpec = false,
  isMetaData = false,
) {
  let flatSchema = convertNestedToFlat(
    inputSchema,
    requiredProps,
    startRowIndex,
    parentName,
    null,
    typeSuffix,
    controlledByAttr,
    0,
    isFromSchemaSpec,
    isMetaData,
  );

  //TODO: NEX-1102:Temp for JSON array of objects
  let controllingAttrsList = _.reduce(
    flatSchema,
    function (result, attr, idx) {
      if (_.has(attr, '__controlledBy')) {
        let controllingAttr = attr.__controlledBy;
        result[controllingAttr] = _.has(result, controllingAttr)
          ? [...result[controllingAttr], attr.__name]
          : [attr.__name];
      }
      return result;
    },
    {},
  );

  _.forEach(controllingAttrsList, (controlsAttrs, attrName) => {
    let controllingAttrIdx = _.findIndex(flatSchema, (attr, idx) => {
      return attr.__name === attrName;
    });
    flatSchema[controllingAttrIdx].__controls = controlsAttrs;
  });

  return flatSchema;
}

function getSchemaFromSamples(samples, isMetaData = false) {
  if (!_.isArray(samples)) {
    return [];
  }

  const mergedSamples = _.merge({}, ...samples);

  return flattenSchema(
    getPropertiesFromSamples(mergedSamples),
    undefined,
    undefined,
    undefined,
    undefined,
    null,
    false,
    isMetaData,
  );
}

function getPropertiesFromSamples(samples) {
  return _.mapValues(samples, (value) => {
    if (_.isPlainObject(value)) {
      return {
        type: 'object',
        properties: getPropertiesFromSamples(value),
      };
    }

    if (_.isArray(value)) {
      return {
        type: 'array',

        // expecting only array of strings for the simple case of metadata
        items: { type: 'string' },
      };
    }

    if (_.isBoolean(value)) {
      return { type: 'boolean' };
    }

    if (_.isNumber(value)) {
      return { type: 'number' };
    }

    if (_.isNull(value)) {
      return { type: 'null' };
    }

    return { type: 'string' };
  });
}

function getAttrSchema(schema, attrName) {
  return schema?.[attrName.substring(attrName.lastIndexOf('.') + 1)];
}

let DataSchemaProcessor = {
  flattenSchema,
  getSchemaFromSamples,
};

export default DataSchemaProcessor;
